import { useParams } from 'react-router-dom';
import { ManagementSection } from './ManagementSection';
import { VenueTastingExperiencesManagement } from '../../components/VenueTastingExperiencesManagement';

export const ExperiencesSection = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <ManagementSection
      title="Manage Experiences"
      description="Design and manage tasting experiences, tours, and educational programs that showcase your wines and venue."
      status="active"
    >
      <VenueTastingExperiencesManagement venueId={id || ''} />
    </ManagementSection>
  );
};